import 'react-slidedown/lib/slidedown.css';

import * as React from 'react';
import classnames from 'classnames';

const SlideDown = require('react-slidedown').SlideDown;

export interface DiscountProps {
    title: string;
    description: string;
}

export interface Props {
    discounts: DiscountProps[];
    isShown: boolean;
}

export interface State {
    isShown: boolean;
}

export default class Discounts extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.handleToggleClick = this.handleToggleClick.bind(this);
        this.state = {
            isShown: props.isShown,
        };
    }

    public render() {
        return (
            <div className='VenuePage--detail VenuePage--detail__expandable '>
                <div className='VenuePage--detail-headline-container' onClick={this.handleToggleClick}>
                    <h3 className='VenuePage--detail-headline VenuePage--detail-headline__expandable'>
                        Promotions
                        <i
                            className={classnames('icon-hb-nx-arrow-down-16', { 'icon-hb-nx-arrow-down-16__flipped': this.state.isShown })}
                        />
                    </h3>
                </div>

                <div className='VenuePage--additional-detail-container'>
                    <SlideDown className={'VenuePage--row'}>
                        {this.state.isShown && (
                            <div className='VenuePage--additional-detail'>
                                <div className='VenuePage--additional-detail__discounts'>
                                    {this.props.discounts.map((discount, idx) => (
                                        <div className='VenuePage--discount-box' key={idx}>
                                            <i className='icon-hb-tag-b VenuePage--discount-icon' />

                                            <p className='VenuePage--t-bold'>{discount.title}</p>
                                            <p>{discount.description}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </SlideDown>
                </div>
            </div>
        );
    }

    private handleToggleClick(e: React.SyntheticEvent<HTMLElement>) {
        this.setState({ isShown: !this.state.isShown });
    }
}
